<template>
  <router-link tag="li" class="nav-item nav-dropdown" :to="url" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
      <AppIcon :name="icon" class="nav-icon" inherit-size />
      <span>{{ name }}</span>
      <AppIcon name="chevron-down" class="nav-dropdown-chevron" inherit-size />
    </div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  name: 'AppSidebarNavDropdown',
  props: {
    name: { type: String, default: '' },
    url: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
  methods: {
    handleClick(event) {
      event.preventDefault()
      event.currentTarget.parentElement.classList.toggle('open')
    },
  },
}
</script>
